export default __webpack_public_path__ + "assets/images/partners_08_barcino_tours.jpg";